<template lang="pug">
  v-container.pa-5
    slot(name="title")
    div.mt-8.mb-3
      froala(id="edit" :tag="'textarea'" :config="config" v-model="form.landing_field" @focus="")

</template>

<script>
import { mapActions, mapState } from 'vuex'
import Vue from 'vue'
import 'froala-editor/js/plugins.pkgd.min.js';
import 'froala-editor/js/third_party/font_awesome.min';
//import CodeMirror from "codemirror";
//import "codemirror/mode/xml/xml";
//import "codemirror/lib/codemirror.css";
import 'froala-editor/css/froala_editor.pkgd.min.css';
import FroalaEditor from 'froala-editor/js/froala_editor.min'
import VueFroala from 'vue-froala-wysiwyg'
Vue.use(VueFroala)
// FroalaEditor.DefineIcon('textColor', {SRC: require('@/assets/images/font-color.svg'), ALT: 'text color', template: 'image'});
// FroalaEditor.DefineIcon('backgroundColor', {SRC: require('@/assets/images/font-bg.svg'), ALT: 'text background color', template: 'image'});
FroalaEditor.DefineIcon('paragraphFormat',{SVG_KEY: 'fontSize'}) 
FroalaEditor.DefineIcon('moreText',{SVG_KEY: 'more'}) 
// FroalaEditor.RegisterCommand('imageButton', {
//   title: 'Image',
//   icon: 'imageIcon'
// });
 
export default {
  name: 'LandingPageEditor',
  props: ['parentForm'],
  data: vm => ({
    isLoading: false,
    config: {
      events: {
        'image.beforeUpload' (files) {
          var editor = this
          if (!files.length) { return }
          let file = files[0]
          var params = new FormData()
          params.append('file', file)
          vm.$axios.post(`/documents/`, params)
            .then(resp => {
              let url = resp.data.file
              url = url.replace('https://cdn.yezza.io', 'https://img.yezza.io/full-fit-in/700x700')
              editor.image.insert(url, false, null, editor.image.get())
            })
            .catch(() => {
              this.showMessage(['error', this.$t('error_message.unable_to_upload_document')])
            })
          return false
        },
        initialized: function() {
          const editor = this;
          FroalaEditor.DefineIcon('textIcon', {NAME: 'Set Background', template: 'text'});
          FroalaEditor.RegisterCommand('setBackground', {
            title: 'Set Background Color for Section',
            focus: false,
            icon: 'textIcon',
            undo: true,
            refreshAfterCallback: false,
            callback: function() {
             const backgroundColor = prompt('Enter a background color (e.g., #FF5733):');
              if (backgroundColor) {
                const sectionTagStart = '<section style="background-color: ' + backgroundColor + ';">';
                const sectionTagEnd = '</section>';
                const selectedElement = editor.selection.element();
                const originalHtml = selectedElement.outerHTML;

                selectedElement.outerHTML = sectionTagStart + originalHtml + sectionTagEnd;
              }
            }
          });

        }
      },
      
      key: process.env.VUE_APP_FROALA_API_KEY,
      attribution: false,
      codeBeautifierOptions: {
        indent_inner_html: false,
        indent_size: 4
      },
      // codeMirror: CodeMirror,
      height: screen.width >= 600 ? Number(window.innerHeight) - 320 : Number(window.innerHeight) - 200,
      // toolbarStickyOffset: vm.$vuetify.breakpoint.xs ? 60 : 100,
      toolbarSticky: false,
      toolbarButtons: {
        'moreText': {
          'buttons': [ 'undo', 'paragraphFormat', 'textColor','backgroundColor', 'insertImage', 'setBackground','insertVideo', 'bold', 'italic', 'underline', 'strikeThrough', /*'emoticons',*/ 'alignLeft', 'alignCenter', 'alignRight', 'alignJustify', 'formatOL', 'formatUL', 'redo', 'fullscreen', 'html',  ],
          'buttonsVisible': 6
        }
      },
      customButtons: {
        setBackground: '<button class="fr-command fr-btn" data-cmd="setBackground" title="Set Background Color for Section">Set BG</button>'
      },
      quickInsertEnabled: false,
      imageInsertButtons: ['imageBack', '|', 'imageUpload', 'imageByURL'],
      imageEditButtons: ['imageCaption', 'imageRemove', 'imageLink', 'linkOpen', 'linkEdit', 'linkRemove'],
      imageResizeWithPercent: true,
      videoInsertButtons: ['videoBack', '|', 'videoByURL'],
      fontSize: ['10', '12', '14', '18', '30', '60', '96'],
      videoEditButtons: ['videoReplace', 'videoRemove'],
      // colorsText : ['#333333','#848484','#A66049','#E06E38','#DBAA00','#008364', '#2C81E4','#6F62FF','#DC3B75','#CD3300'],
      // colorsBackground : ['#333333','#848484','#A66049','#E06E38','#DBAA00','#008364', '#2C81E4','#6F62FF','#DC3B75','#CD3300'],
      paragraphFormat: {
        N: 'Normal',
        H1: 'Headline',
        H3: 'Subheadline',
        H4: 'Title'
      }
    },
  }),
  computed: {
    ...mapState('user', ['member']),
    form: {
      get() {
        return this.parentForm
      },
      set(newValue) {
        this.$emit('update:parentForm', newValue)
      }
    }
  },
  mounted () {
  },
  watch: {
  },
  methods: {
    ...mapActions([
      'showMessage'
    ]),
  }
}
</script>

<style lang="scss" scoped>

::v-deep .fr-toolbar .fr-command.fr-btn, .fr-popup .fr-command.fr-btn, .fr-modal .fr-command.fr-btn {
  margin: 2px;
}

::v-deep .fr-toolbar .fr-btn-grp {
  margin-left: 4px;
}

::v-deep .fr-toolbar.fr-toolbar-open {
  padding-bottom: 0
}

::v-deep p {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: #{(-40/1000)}em !important;
  margin-bottom: 0px !important;
}

::v-deep ul, ol {
padding-left: 0px;
}

::v-deep li {
  font-family: $body-font-family;
  font-size: 16px !important;
  line-height: 20px !important;
  letter-spacing: #{(-40/1000)}em !important;
}
</style>

